import { $consts } from 'src/plugins'

export default {
  [$consts['LIFECYCLE/EDIT_PAGE_CONFIG_LOADED']] (EditContext: any, props: any, list: { listProps: any }) {
    // formId 没有，代表是新增，此时 onEditPageFormLoaded 不会被执行
    if (!props.current.formData?.formId) {
      const fromWhere = list?.listProps?.formData?.fromWhere
      const match = (
        fromWhere?.pageType === $consts['TABLE/FORM_TYPE_LIST_SUBPAGE']
        && fromWhere?.locateType === $consts['TABLE/PAGE_LOCATE_LIST_ROW']
        && fromWhere?.data
      )
      const parentRecord = match?.record
      if (parentRecord) {
        if (parentRecord.IMPORT_CONFIG_ID) {
          EditContext.setFormBase({
            IMPORT_CONFIG_ID: parentRecord.IMPORT_CONFIG_ID,
            PARENT_ID: parentRecord.ID
          })
        } else {
          EditContext.setFormBase({
            IMPORT_CONFIG_ID: parentRecord.ID,
          })
        }
      }
    }
  },
}